import React from 'react';

import Tooltip from '@ui/Tooltip';

import classes from './style.module.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
  icon?: string;
}

const InfoPop = React.memo(function InfoPop({ children, className, icon = 'icon-help-circle' }: Props) {
  return (
    <Tooltip arrow={false} className={classes['InfoPop-tooltip']} content={children} interactive>
      <i
        aria-label="Information"
        className={`${classes['InfoPop-helpIcon']} ${icon} ${className}`}
        role="button"
        tabIndex={0}
      />
    </Tooltip>
  );
});

export default InfoPop;
